import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Alert, Layout, Row, Col, Card, Button, Divider, message, Spin } from 'antd';
import SubnavBar from '../subnav_bar/SubnavBar';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	getStartDateFieldName,
	getEndDateFieldName,
	getEntitiesByIdWithSearch,
	isSupplierPayingCustomer,
} from '../../utils/DataAccessUtils';
import { workOrderPrioritiesRestCrudThunksForSupplier } from '../../thunks/work_order_priorities_thunks';
import {
	fetchAllFieldTechs,
	fieldTechsRestCrudThunksForSupplier,
} from '../../thunks/field_techs_thunks';
import { assetTypesRestCrudThunksForSupplier } from '../../thunks/asset_types_thunks';
import { resolutionTypesRestCrudThunksForSupplier } from '../../thunks/resolution_types_thunks';
import { plannedMaintenanceSchedulesRestCrudThunksForSupplier } from '../../thunks/planned_maintenance_schedules_thunks';
import { assetsRestReadThunk } from '../../thunks/assets_thunks';
import { ContractorPrivateNetworksRestCrudThunksForSupplier } from '../../thunks/contractors_private_networks_thunks';
import { fetchDistinctAreasHeirarchy } from '../../thunks/areas_thunks';
import { contractorClientsRestCrudThunksForSupplier } from '../../thunks/contractor_clients_thunks';
import { contractorLocationsRestCrudThunksForSupplier } from '../../thunks/contractor_locations_thunks';
import { problemTypesHeirarchicalForSupplier } from '../../thunks/problem_types_thunks';
import { fetchSupplierFacilitiesInPrivateNetworkForSupplier } from '../../thunks/supplier_facilities_thunks';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import { contactsRestCrudThunksForSupplierForThirdPartySuppliers } from '../../thunks/contacts_thunks';
import EventCalendar from '../event_calendar/EventCalendar';
import stackingLayout from '../event_calendar/stackingLayout';
import { getFieldTechDisplayName } from '../../utils/FieldTechUtils';
import {
	capitalize,
	formatDateForParam,
	isDatePastDue,
	formatDateForLocationTimeZone,
} from '../../utils/DataFormatterUtils';
import moment from 'moment';
import SelectedFilters from '../selected_filters_pills/SelectedFilters';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import {
	fetchWorkOrders,
	updateFiltersWorkOrders,
	clearFiltersWorkOrders,
} from '../../thunks/work_orders_thunks_wrapper';
import {
	rescheduleServiceCallForSupplier,
	scheduleServiceCallForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import {
	getSanitisedWorkOrder,
	getWorkOrderArchivalKey,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	isAValidAndParitalWorkOrder,
	getServiceCallLeadTechnicianEmail,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Views } from 'react-big-calendar';
import AssignedFilters from '../WorkOrderTable/AssignedFilters';
import { ASSIGNED_FILTERS } from '../WorkOrderTable/config/assigned';
import WorkOrderTable from '../WorkOrderTable';
import { CaretDownFilled, CloseOutlined } from '@ant-design/icons';
import { Sorter } from '../WorkOrderTable/sorters/Sorters';
import { WORK_ORDER_SORTERS } from '../WorkOrderTable/config/sorters/sorters';
import ServiceCalendarWorkOrderRow from './ServiceCalendarWorkOrderRow';
import {
	useCommonFilterConfiguration,
	useSupplierFilterConfiguration,
} from '../../hooks/workOrderHooks';
import { brandsRestCrudThunksForSupplier } from '../../thunks/brands_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import ScheduleServiceCallModalForm from '../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import OWSearchInput from '../common/OWSearchInput';
import { createSelector } from 'reselect';
import { withCurrentUser } from '../../hooks/withCurrentUser';
import useMountEffect from '../../hooks/useMountEffect';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { withUserType } from '../withUserType';
import {
	WORK_ORDER_STATUSES,
	TECH_SCHEDULED_STATUSES,
	SCHEDULE_TECH_STATUSES,
} from '../../constants/WorkOrderStatuses';
import Filters from '../WorkOrderTable/filters/filters';
import { isInternalTech } from '../../utils/AuthUtils';

import CustomCalendarToolbar from '../event_calendar/CustomCalendarToolbar';
import {
	CALENDAR_COMPONENTS,
	TechnicianColumnHeader,
	TechnicianNavContext,
} from './TechnicianColumnHeader';
import { TechnicianFilterPopover } from './TechnicianFilterPopover';
import { SUBCONTRACTED_FILTERS } from '../WorkOrderTable/config/subcontracted';
import SubcontractedFilters from '../WorkOrderTable/SubContractedFilters';

const { Content } = Layout;
const WORK_ORDERS_CALENDAR_TARGET_COLLECTION = 'workOrdersCalendarIndex';
const WORK_ORDERS_SCHEDULE_TARGET_COLLECTION = 'workOrdersScheduleIndex';
const LAST_SERVICE_CALL_SCHEDULED_AT_FIELD = FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT;
const SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION = 'serviceCalendarTechnicians';
const MAX_VISIBLE_TECHNICIAN_COLUMNS = 4;
const CALENDAR_PAGE_SIZE = 1000;

// Handle the gone filters because these params might still be saved in URLs with customers.
const UNSUPPORTED_CALENDAR_QUERY_PARAMS = [
	'current',
	'pageSize',
	'displayStatus',
	'status',
	'displayStatuses',
	'statuses',
];
const START_TIME_ONLY_EVENT_STATUSES = ['Scheduled', 'PastDue', 'CheckedIn'];
export const encodeUTCAdjustedDateWithUserTimeZone = (date, isEndOfDay = false) => {
	const localTz = moment.tz.guess();
	const local = moment(date).tz(localTz, true);
	if (date) {
		return isEndOfDay ? local.clone().endOf('day').utc() : local.clone().startOf('day').utc();
	}
	return undefined;
};

// The span the calendar actually draws, as local moments.
const getViewRange = (view, date) => {
	const isWeekView = view === Views.WEEK;
	return {
		viewStart: isWeekView
			? moment(date).startOf('week').isoWeekday(1).startOf('day')
			: moment(date).startOf('day'),
		viewEnd: isWeekView
			? moment(date).endOf('week').isoWeekday(7).endOf('day')
			: moment(date).endOf('day'),
	};
};

// A service call checked into in an earlier week and never checked out is still running, so it
// belongs on this view — but the API filters on serviceScheduledAt, which for that call sits before
// this view starts, so it is never returned. Ask for the preceding week as well and let
// transformRecords drop whatever does not reach into the view. Only the start is widened: the end
// already bounds what can be relevant. A call still running from further back than this stays
// missing, which is the limit of filtering on the scheduled date alone.
const CALENDAR_LOOKBACK_DAYS = 7;

const calculateDateRangeForView = (view, date) => {
	const { viewStart, viewEnd } = getViewRange(view, date);
	const fetchStart = viewStart.clone().subtract(CALENDAR_LOOKBACK_DAYS, 'days');

	return {
		startDate: formatDateForParam(encodeUTCAdjustedDateWithUserTimeZone(fetchStart)),
		endDate: formatDateForParam(encodeUTCAdjustedDateWithUserTimeZone(viewEnd, true)),
	};
};

const selectCalendarWorkOrders = createSelector(
	(state: any) => state.work_orders,
	(workOrdersSlice) =>
		getEntitiesByIdWithSearch(
			nullSafeGetOrElse(
				`${WORK_ORDERS_CALENDAR_TARGET_COLLECTION}.recordsIds`,
				workOrdersSlice,
				[]
			),
			workOrdersSlice
		)
);

const selectCalendarTechnicians = createSelector(
	(state: any) => state.field_techs,
	(fieldTechsSlice) =>
		getEntitiesByIdWithSearch(
			nullSafeGetOrElse(
				`${SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION}.recordsIds`,
				fieldTechsSlice,
				[]
			),
			fieldTechsSlice
		)
);

require('./SupplierServiceCallCalendarPage.less');

const CALENDAR_TOOLBAR_VIEWS = [Views.WEEK, Views.DAY];

const SupplierServiceCallCalendarPageV2 = (props: any) => {
	const {
		workOrders,
		data,
		fetchData,
		updateFilters,
		clearFilters,
		fetchLocations,
		fetchWorkOrderPriorities,
		fetchMultipleFieldTechs,
		fetchFieldTechs,
		locations,
		workOrderPriorities,
		fieldTechs,
		location,
		currentUser,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
		users,
		fetchUsers,
		fetchMultipleUsers,
		areas,
		fetchAreasDistinct,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		companyConfig,
		rescheduleServiceCall,
		scheduleServiceCall,
		getFullWorkOrder,
		syncScheduleTechnicianFilter,
		technicians,
		technicianCount,
		fetchAllFieldTechs,
	} = props;

	const { fetching, pagination } = workOrders;

	const [showScheduleWOs, setShowScheduleWOs] = useState(false);
	const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
	const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
	const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
	const [newScheduledTime, setNewScheduledTime] = useState(null);
	const [isLoadingFullWorkOrder, setIsLoadingFullWorkOrder] = useState(false);
	const [calendarDate, setCalendarDate] = useState(new Date());
	const [calendarView, setCalendarView] = useState<string>(Views.DAY);
	const [scrollToTime, setScrollToTime] = useState(new Date());
	const [technicianSelection, setTechnicianSelection] = useState<string[]>(null);
	const [visibleTechnicianOffset, setVisibleTechnicianOffset] = useState(0);
	const calendarScrollApiRef = useRef<{
		scrollByColumns: (delta: number) => void;
		scrollToColumn: (index: number) => void;
	} | null>(null);
	const [weekTechnicianIndex, setWeekTechnicianIndex] = useState(0);
	const [dropTechnicianEmail, setDropTechnicianEmail] = useState(null);
	const rescheduleFormRef = useRef(null);
	const scheduleFormRef = useRef(null);

	// Calculate staleDays from companyConfig
	const staleDays = useMemo(
		() => nullSafeGetOrElse('config.workOrder.stale.afterXDays', companyConfig, 14),
		[companyConfig]
	);

	const techniciansByEmail = useMemo(() => {
		const lookup = {};
		(technicians || []).forEach((technician) => {
			const email = nullSafeGet('email', technician);
			if (email) {
				lookup[email] = technician;
			}
		});
		return lookup;
	}, [technicians]);

	const defaultTechnicianEmails = useMemo(
		() =>
			(technicians || [])
				.map((technician) => nullSafeGet('email', technician))
				.filter(Boolean),
		[technicians]
	);

	const orderedTechnicianEmails = technicianSelection || defaultTechnicianEmails;

	const orderedTechnicians = useMemo(
		() => orderedTechnicianEmails.map((email) => techniciansByEmail[email]).filter(Boolean),
		[orderedTechnicianEmails, techniciansByEmail]
	);

	const resolvedTechnicianEmails = useMemo(
		() => orderedTechnicians.map((technician) => nullSafeGet('email', technician)),
		[orderedTechnicians]
	);

	const resetTechnicianScroll = useCallback(() => {
		setVisibleTechnicianOffset(0);
		setWeekTechnicianIndex(0);
		if (calendarScrollApiRef.current) {
			calendarScrollApiRef.current.scrollToColumn(0);
		}
	}, []);

	const handleTechnicianSelectionChange = useCallback(
		(nextOrderedEmails) => {
			setTechnicianSelection(nextOrderedEmails);
			resetTechnicianScroll();
		},
		[resetTechnicianScroll]
	);

	const handleRemoveTechnician = useCallback(
		(email) => {
			const removedIndex = orderedTechnicianEmails.indexOf(email);
			const nextEmails = orderedTechnicianEmails.filter((selectedEmail) => selectedEmail !== email);
			setTechnicianSelection(nextEmails);

			// Deliberately not resetTechnicianScroll(): closing one column should leave the calendar
			// where it is rather than send it back to the first technician. Only the viewport's own
			// column moves — dropping a column from the left of it shifts every later column one place,
			// so the offset follows; dropping one at or after it leaves the offset alone. Either way it
			// is clamped to the shorter roster's last page.
			const currentMaxOffset = Math.max(
				0,
				orderedTechnicianEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS
			);
			const currentOffset = Math.min(visibleTechnicianOffset, currentMaxOffset);
			const removedBeforeViewport = removedIndex >= 0 && removedIndex < currentOffset;
			setVisibleTechnicianOffset(
				Math.min(
					removedBeforeViewport ? currentOffset - 1 : currentOffset,
					Math.max(0, nextEmails.length - MAX_VISIBLE_TECHNICIAN_COLUMNS)
				)
			);
			if (removedBeforeViewport && calendarScrollApiRef.current) {
				calendarScrollApiRef.current.scrollByColumns(-1);
			}
		},
		[orderedTechnicianEmails, visibleTechnicianOffset]
	);

	// `fetchAllFieldTechs` walks the roster a page at a time, so the whole run is tracked here rather
	// than through the slice's per-page fetching flag.
	const [loadingAllTechnicians, setLoadingAllTechnicians] = useState(true);
	const loadAllTechnicians = useCallback(() => {
		setLoadingAllTechnicians(true);
		return fetchAllFieldTechs()
			.catch(() => message.error('Failed to load technicians. Please try again.'))
			.finally(() => setLoadingAllTechnicians(false));
	}, [fetchAllFieldTechs]);

	// "Mine" for someone with no calendar of their own: the roster has finished loading and still has
	// no column for them. Distinct from an emptied selection, which the Techs control can fix. The
	// copy stays clear of why they have no column, since that depends on assignment and role rules
	// this page does not model.
	const currentUserEmail = nullSafeGet('email', currentUser);
	const isViewingOwnCalendarOnly =
		Boolean(currentUserEmail) &&
		technicianSelection !== null &&
		technicianSelection.length === 1 &&
		technicianSelection[0] === currentUserEmail;
	const currentUserHasNoTechnicianRecord =
		!loadingAllTechnicians && isViewingOwnCalendarOnly && !techniciansByEmail[currentUserEmail];

	// AssignedFilters picks the highlighted tab by matching these values against the tab's own filter
	// set, and its "Mine" tab carries fieldTechnicianEmail. This page narrows by technician column and
	// deliberately keeps that filter out of the request (see handleAssignedFilterChange), which the
	// match reads as "no tab selected". Supply it here only so the control recognises its own choice;
	// what gets sent to the server is unaffected.
	const assignedFilterValue = useMemo(() => {
		const activeFilters = nullSafeGetOrElse('filters', workOrders, {});
		if (nullSafeGet('assigned', activeFilters) !== 'me') {
			return activeFilters;
		}
		return { ...activeFilters, fieldTechnicianEmail: currentUserEmail };
	}, [workOrders, currentUserEmail]);

	// These filters are not removed as per Keenan so we need to ensure that a saved url does not inject these and gets cleaned up
	const sanitizedSearch = useMemo(() => {
		const params = new URLSearchParams(nullSafeGetOrElse('search', location, ''));
		const removed = UNSUPPORTED_CALENDAR_QUERY_PARAMS.filter((param) => params.has(param));
		removed.forEach((param) => params.delete(param));
		return removed.length > 0 ? params.toString() : null;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useMountEffect(() => {
		if (sanitizedSearch !== null) {
			props.history.replace(`${location.pathname}${sanitizedSearch ? `?${sanitizedSearch}` : ''}`);
		}
		fetchData(
			{ ...location, search: sanitizedSearch === null ? location.search : sanitizedSearch },
			calendarDate,
			calendarView
		);
		loadAllTechnicians();
	});

	const handleClearAndUpdateFilters = () => {
		const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
		const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

		const startDate = nullSafeGet(`filters.${startDateFieldName}`, workOrders);
		const endDate = nullSafeGet(`filters.${endDateFieldName}`, workOrders);

		clearFilters({
			[startDateFieldName]: startDate,
			[endDateFieldName]: endDate,
		});
	};

	// Helper function to update date filters based on view and date
	const updateDateFiltersForView = useCallback(
		(view, date) => {
			const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const { startDate, endDate } = calculateDateRangeForView(view, date);

			if (startDate && endDate) {
				updateFilters({
					[startDateFieldName]: startDate,
					[endDateFieldName]: endDate,
				});
			}
		},
		[updateFilters]
	);

	const handleEventDrop = async ({ event, start, end, resourceId }) => {
		const woStatus = event.status;
		const isReschedulable =
			TECH_SCHEDULED_STATUSES.includes(woStatus) || woStatus === WORK_ORDER_STATUSES.techEnRoute;
		const isSchedulable = SCHEDULE_TECH_STATUSES.includes(woStatus);

		if (!isReschedulable && !isSchedulable) {
			message.warning('This work order cannot be scheduled or rescheduled.');
			return;
		}

		// Sanitize the work order first
		const sanitizedWorkOrder = getSanitisedWorkOrder(event, true);

		// Fetch full work order if needed
		let fullWorkOrder = sanitizedWorkOrder;
		if (isAValidAndParitalWorkOrder(sanitizedWorkOrder)) {
			if (isLoadingFullWorkOrder) {
				return;
			}

			setIsLoadingFullWorkOrder(true);
			const hideLoading = message.loading('Loading work order details...', 0);
			try {
				const fetchedWorkOrder = await getFullWorkOrder(sanitizedWorkOrder.id);
				fullWorkOrder = getSanitisedWorkOrder(fetchedWorkOrder, true);
				hideLoading();
			} catch (error) {
				hideLoading();
				message.error('Failed to load work order details. Please try again.');
				setIsLoadingFullWorkOrder(false);
				return;
			} finally {
				setIsLoadingFullWorkOrder(false);
			}
		}

		const leadTechnicianEmail = getServiceCallLeadTechnicianEmail(fullWorkOrder);
		setDropTechnicianEmail(resourceId || scopedTechnicianEmail || leadTechnicianEmail || null);

		// Set the selected work order and new scheduled time
		setSelectedWorkOrder(fullWorkOrder);
		setNewScheduledTime(start);

		if (isReschedulable) {
			setRescheduleModalVisible(true);
		} else {
			setScheduleModalVisible(true);
		}
	};

	const handleRescheduleSubmit = () => {
		if (!rescheduleFormRef.current || !rescheduleFormRef.current.props) {
			return;
		}

		const form = rescheduleFormRef.current.props.form;
		if (!form) {
			return;
		}

		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] ||
				nullSafeGet('location.timeZoneId', selectedWorkOrder);
			const lastServiceCall = nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {});
			const formData = {
				...lastServiceCall,
				...values,
				serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				workOrderId: nullSafeGet('id', selectedWorkOrder),
			};

			rescheduleServiceCall(formData)
				.then(() => {
					setRescheduleModalVisible(false);
					// Move calendar to the rescheduled time
					let newDate = calendarDate;
					if (values.serviceScheduledAt) {
						const scheduledMoment = moment(values.serviceScheduledAt);
						if (scheduledMoment.isValid()) {
							const scheduledDate = scheduledMoment.toDate();
							setScrollToTime(scheduledDate);
							if (calendarView === Views.DAY) {
								setCalendarDate(scheduledDate);
								newDate = scheduledDate;
							}
						}
					} else if (newScheduledTime) {
						const scheduledDate = new Date(newScheduledTime);
						setScrollToTime(scheduledDate);
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							newDate = scheduledDate;
						}
					}
					setSelectedWorkOrder(null);
					setNewScheduledTime(null);
					setDropTechnicianEmail(null);
					fetchData(location, newDate, calendarView);
					message.success('Service call rescheduled.');
				})
				.catch((error) => {
					console.error('Failed to reschedule service call:', error);
					message.error('Failed to reschedule service call. Please try again.');
				});
		});
	};

	const handleRescheduleCancel = () => {
		setRescheduleModalVisible(false);
		setSelectedWorkOrder(null);
		setNewScheduledTime(null);
		setDropTechnicianEmail(null);
	};

	const handleScheduleSubmit = () => {
		if (!scheduleFormRef.current || !scheduleFormRef.current.props) {
			return;
		}

		const form = scheduleFormRef.current.props.form;
		if (!form) {
			return;
		}

		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] ||
				nullSafeGet('location.timeZoneId', selectedWorkOrder);
			const formData = {
				...values,
				serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				workOrderId: nullSafeGet('id', selectedWorkOrder),
				supplierFacilityId: nullSafeGetOrElse('supplierFacilityId', selectedWorkOrder, null),
			};

			scheduleServiceCall(formData)
				.then(() => {
					setScheduleModalVisible(false);
					// Move calendar to the scheduled time
					let newDate = calendarDate;
					if (values.serviceScheduledAt) {
						const scheduledMoment = moment(values.serviceScheduledAt);
						if (scheduledMoment.isValid()) {
							const scheduledDate = scheduledMoment.toDate();
							setScrollToTime(scheduledDate);
							if (calendarView === Views.DAY) {
								setCalendarDate(scheduledDate);
								newDate = scheduledDate;
							}
						}
					} else if (newScheduledTime) {
						const scheduledDate = new Date(newScheduledTime);
						setScrollToTime(scheduledDate);
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							newDate = scheduledDate;
						}
					}
					setSelectedWorkOrder(null);
					setNewScheduledTime(null);
					setDropTechnicianEmail(null);
					fetchData(location, newDate, calendarView);
					message.success('Service call scheduled.');
				})
				.catch((error) => {
					console.error('Failed to schedule service call:', error);
					message.error('Failed to schedule service call. Please try again.');
				});
		});
	};

	const handleScheduleCancel = () => {
		setScheduleModalVisible(false);
		setSelectedWorkOrder(null);
		setNewScheduledTime(null);
		setDropTechnicianEmail(null);
	};

	const draggableAccessor = (event) => {
		// Allow dragging for reschedulable WOs (TechScheduled, TechRescheduled, TechEnRoute)
		// and schedulable WOs (TechAssigned, ConfirmedByServiceProvider, etc.)
		const woStatus = event.status;
		return (
			TECH_SCHEDULED_STATUSES.includes(woStatus) ||
			woStatus === WORK_ORDER_STATUSES.techEnRoute ||
			SCHEDULE_TECH_STATUSES.includes(woStatus)
		);
	};

	const transformRecords = useMemo(() => {
		if (!data || data.length === 0) {
			return [];
		}
		const { viewStart, viewEnd } = getViewRange(calendarView, calendarDate);
		const viewStartMs = viewStart.valueOf();
		const viewEndMs = viewEnd.valueOf();

		return data.reduce((acc, workOrder) => {
			const lastServiceCall = nullSafeGet('lastServiceCall', workOrder);
			const serviceScheduledAt = nullSafeGet('serviceScheduledAt', lastServiceCall);

			if (!serviceScheduledAt) {
				return acc;
			}

			const checkInTime = nullSafeGet('checkInTime', lastServiceCall);
			const checkOutTime = nullSafeGet('checkOutTime', lastServiceCall);
			const displayStatus = nullSafeGet('displayStatus', workOrder);
			const status = nullSafeGet('status', workOrder);
			const dueDate = nullSafeGet('dueDate', workOrder);

			// Determine event status: Scheduled, PastDue, CheckedIn, OnHold, or Completed

			let eventStatus = 'Scheduled';

			if (
				displayStatus === WORK_ORDER_DISPLAY_STATUSES.hold ||
				status === WORK_ORDER_STATUSES.workIncompleteWithReason ||
				status === WORK_ORDER_STATUSES.workUnsatisfactory
			) {
				eventStatus = 'OnHold';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.complete) {
				eventStatus = 'Completed';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.pending) {
				eventStatus = 'Pending';
			} else if (checkInTime && !checkOutTime) {
				eventStatus = 'CheckedIn';
			} else if (displayStatus === 'Completed') {
				eventStatus = 'Completed';
			} else if (eventStatus === 'Scheduled' && dueDate && isDatePastDue(dueDate)) {
				eventStatus = 'PastDue';
			}

			const title = `${capitalize(nullSafeGetOrElse('title', workOrder, 'Scheduled'))}`;

			const startTime = checkInTime || serviceScheduledAt;
			const startMoment = moment(startTime).local();
			if (!startMoment.isValid()) {
				return acc;
			}
			const startDateObj = startMoment.toDate();

			// `end` drives both the card's height and react-big-calendar's overlap math, so it stays the
			// real end of the service call — never padded. A call too short to draw legibly is handled in
			// CSS (`.rbc-day-slot .rbc-event` has a pixel `min-height`), which grows the box without
			// telling the calendar the technician was busy longer than they were.
			let endDateObj;
			if (
				(eventStatus === 'CheckedIn' || eventStatus === 'Completed' || eventStatus === 'OnHold') &&
				checkOutTime
			) {
				const checkOutMoment = moment(checkOutTime).local();
				endDateObj = checkOutMoment.isValid()
					? checkOutMoment.toDate()
					: moment(startDateObj).add(1, 'hour').toDate();
			} else if (checkInTime && !checkOutTime) {
				endDateObj = moment().toDate();
			} else {
				endDateObj = moment(startDateObj).add(1, 'hour').toDate();
			}

			// The fetch reaches CALENDAR_LOOKBACK_DAYS before the view, so calls that finished before it
			// began come back too. Keep only the ones whose span actually touches the view.
			if (endDateObj.getTime() < viewStartMs || startDateObj.getTime() > viewEndMs) {
				return acc;
			}

			const leadTechnicianEmail = getServiceCallLeadTechnicianEmail(workOrder);
			const showsStartTimeOnly = START_TIME_ONLY_EVENT_STATUSES.indexOf(eventStatus) >= 0;
			const displayEnd = showsStartTimeOnly || calendarView === Views.WEEK ? undefined : endDateObj;

			const event = {
				...workOrder,
				title,
				category: nullSafeGet('displayStatus', workOrder),
				eventStatus: eventStatus,
				technicianEmails: leadTechnicianEmail ? [leadTechnicianEmail] : [],
				displayEnd,
				start: startDateObj,
				end: endDateObj,
			};

			return acc.concat(event);
		}, []);
	}, [data, calendarView, calendarDate]);

	const workOrderCountsByEmail = useMemo(() => {
		const counts = {};
		transformRecords.forEach((event) => {
			nullSafeGetOrElse('technicianEmails', event, []).forEach((email) => {
				counts[email] = (counts[email] || 0) + 1;
			});
		});
		return counts;
	}, [transformRecords]);

	const maxTechnicianOffset = useMemo(
		() => Math.max(0, orderedTechnicians.length - MAX_VISIBLE_TECHNICIAN_COLUMNS),
		[orderedTechnicians]
	);

	const resourceColumnCount = useMemo(() => {
		const count = orderedTechnicians.length;
		if (count === 0) {
			return 1;
		}
		return count <= MAX_VISIBLE_TECHNICIAN_COLUMNS ? count : 4.5;
	}, [orderedTechnicians.length]);

	const effectiveTechnicianOffset = Math.min(visibleTechnicianOffset, maxTechnicianOffset);
	const effectiveWeekTechnicianIndex = Math.min(
		weekTechnicianIndex,
		Math.max(0, orderedTechnicians.length - 1)
	);
	const weekTechnician = orderedTechnicians[effectiveWeekTechnicianIndex];

	const scopedTechnician =
		calendarView === Views.WEEK
			? weekTechnician
			: orderedTechnicians.length === 1
			? orderedTechnicians[0]
			: undefined;
	const scopedTechnicianEmail = nullSafeGet('email', scopedTechnician);
	const scopedTechnicianLabel = scopedTechnician ? getFieldTechDisplayName(scopedTechnician) : '';

	const technicianResources = useMemo(
		() =>
			orderedTechnicians.map((technician) => ({
				...technician,
				workOrderCount: workOrderCountsByEmail[nullSafeGet('email', technician)] || 0,
			})),
		[orderedTechnicians, workOrderCountsByEmail]
	);

	// Week view shows one technician at a time; day view puts every WO in its own technician column.
	const visibleEvents = useMemo(() => {
		if (calendarView !== Views.WEEK) {
			return transformRecords;
		}
		const weekTechnicianEmail = nullSafeGet('email', weekTechnician);
		if (!weekTechnicianEmail) {
			return [];
		}
		return transformRecords.filter(
			(event) => nullSafeGetOrElse('technicianEmails', event, []).indexOf(weekTechnicianEmail) >= 0
		);
	}, [transformRecords, calendarView, weekTechnician]);

	const scrollTechnicianColumns = useCallback((delta) => {
		if (calendarScrollApiRef.current) {
			calendarScrollApiRef.current.scrollByColumns(delta);
		}
	}, []);

	const handlePreviousTechnicianPage = useCallback(
		() => scrollTechnicianColumns(-1),
		[scrollTechnicianColumns]
	);

	const handleNextTechnicianPage = useCallback(
		() => scrollTechnicianColumns(1),
		[scrollTechnicianColumns]
	);

	const handlePreviousWeekTechnician = useCallback(
		() => setWeekTechnicianIndex((index) => Math.max(0, index - 1)),
		[]
	);

	const handleNextWeekTechnician = useCallback(
		() => setWeekTechnicianIndex((index) => Math.min(index + 1, orderedTechnicians.length - 1)),
		[orderedTechnicians]
	);

	const handleCalendarNavigate = useCallback(
		(date) => {
			setCalendarDate(date);
			updateDateFiltersForView(calendarView, date);
		},
		[calendarView, updateDateFiltersForView]
	);

	const handleCalendarViewChange = useCallback(
		(view) => {
			setCalendarView(view);
			updateDateFiltersForView(view, calendarDate);
		},
		[updateDateFiltersForView, calendarDate]
	);

	const isWeekView = calendarView === Views.WEEK;

	const handleToolbarNavigate = useCallback(
		(action) => {
			if (action === 'TODAY') {
				handleCalendarNavigate(new Date());
				return;
			}
			const unit = isWeekView ? 'week' : 'day';
			const shifted =
				action === 'PREV'
					? moment(calendarDate).subtract(1, unit)
					: moment(calendarDate).add(1, unit);
			handleCalendarNavigate(shifted.toDate());
		},
		[calendarDate, isWeekView, handleCalendarNavigate]
	);

	const renderTechnicianColumnHeader = useCallback(
		(technician) => (
			<TechnicianColumnHeader technician={technician} onRemove={handleRemoveTechnician} />
		),
		[handleRemoveTechnician]
	);

	const technicianNavValue = useMemo(
		() =>
			isWeekView
				? {
						technician: weekTechnician,
						onPrevious: handlePreviousWeekTechnician,
						onNext: handleNextWeekTechnician,
						previousDisabled: effectiveWeekTechnicianIndex <= 0,
						nextDisabled: effectiveWeekTechnicianIndex >= orderedTechnicians.length - 1,
				  }
				: {
						technician: undefined,
						onPrevious: handlePreviousTechnicianPage,
						onNext: handleNextTechnicianPage,
						previousDisabled: effectiveTechnicianOffset <= 0,
						nextDisabled: effectiveTechnicianOffset >= maxTechnicianOffset,
				  },
		[
			isWeekView,
			weekTechnician,
			handlePreviousWeekTechnician,
			handlePreviousTechnicianPage,
			handleNextWeekTechnician,
			handleNextTechnicianPage,
			effectiveWeekTechnicianIndex,
			effectiveTechnicianOffset,
			orderedTechnicians.length,
			maxTechnicianOffset,
		]
	);

	const isInternalTeam = useMemo(() => isInternalTech(currentUser), [currentUser]);

	const assignedFilterItems = useMemo(() => {
		const assignedConfig = ASSIGNED_FILTERS(currentUser);
		return isInternalTeam
			? assignedConfig.items.filter(
					(item) => item.selectVal !== 'team' && item.selectVal !== 'serviceprovider'
			  )
			: assignedConfig.items;
	}, [currentUser, isInternalTeam]);

	const handleAssignedFilterChange = useCallback(
		(filters) => {
			if (filters && filters.assigned === 'me') {
				const currentUserEmail = nullSafeGet('email', currentUser);
				if (currentUserEmail) {
					setTechnicianSelection([currentUserEmail]);
					resetTechnicianScroll();
				}
				updateFilters({ ...filters, fieldTechnicianEmail: undefined });
				return;
			}
			setTechnicianSelection(null);
			updateFilters(filters);
		},
		[currentUser, updateFilters, resetTechnicianScroll]
	);

	const advancedFiltersConfig = useMemo(
		() =>
			isInternalTeam
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
		[currentUser, isInternalTeam]
	);

	const SUPPLIER_FILTER_CONFIG = useSupplierFilterConfiguration({
		fieldTechs,
		updateFilters,
		fetchFieldTechs,
		fetchMultipleFieldTechs,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		currentUser,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
	});
	const COMMON_FILTER_CONFIGS = useCommonFilterConfiguration({
		locations,
		fetchLocations,
		areas,
		fetchAreasDistinct,
		workOrderPriorities,
		fetchWorkOrderPriorities,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		currentUser,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		staleDays,
		updateFilters,
		users,
		fetchUsers,
		fetchMultipleUsers,
	});

	const FILTER_CONFIG = useMemo(() => {
		const defaultConfig: any[] = [...COMMON_FILTER_CONFIGS, ...SUPPLIER_FILTER_CONFIG];

		const advancedFilterConfig =
			advancedFiltersConfig && advancedFiltersConfig.length > 0
				? advancedFiltersConfig.map((filter) => defaultConfig.find((_) => _.fieldName === filter))
				: defaultConfig;
		return advancedFilterConfig.filter(
			(_) =>
				!!_ &&
				_.fieldName !== FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT &&
				_.fieldName !== FILTER_CONFIG_NAMES.TECHNICIAN &&
				_.fieldName !== FILTER_CONFIG_NAMES.NOTES_STATUS
		);
	}, [advancedFiltersConfig, COMMON_FILTER_CONFIGS, SUPPLIER_FILTER_CONFIG]);

	const calendarPreAppliedFilters = useMemo(() => {
		const activeFilters = nullSafeGetOrElse('filters', workOrders, {});
		const filterConfigKeys = new Set(
			FILTER_CONFIG.map((f: any) => f && f.fieldName).filter(Boolean)
		);
		return Object.keys(activeFilters).reduce((acc: any, key) => {
			if (!filterConfigKeys.has(key)) {
				acc[key] = activeFilters[key];
			}
			return acc;
		}, {});
	}, [workOrders, FILTER_CONFIG]);

	const myTimeZone = useMemo(() => moment.tz.guess(), []);

	const customHeader = useCallback(
		({ counts, applySorting, sorters, pagination, applyFilters, filters }) => (
			<>
				<div className="flex flex-row items-start justify-between px-4 pt-4">
					<div className="flex flex-col items-start justify-start gap-y-2">
						<div className="flex flex-col flex-wrap items-start justify-start gap-3">
							<div className="h5medium text-character-primary">
								Schedule Work Orders {pagination.total ? `(${pagination.total})` : null}
							</div>
							{scopedTechnicianEmail ? (
								<div className="bodyregular text-grey-8">
									Showing work orders visible to{' '}
									<span className="font-medium">{scopedTechnicianLabel}</span>
								</div>
							) : null}
							<div className="flex flex-row flex-wrap items-center justify-start gap-2">
								<OWSearchInput
									key="schedule-work-orders-search"
									placeholder="Search "
									onChange={(value) => applyFilters({ search: value })}
									size="small"
									style={{ width: 150 }}
								/>
								<Sorter
									size="small"
									items={WORK_ORDER_SORTERS}
									value={sorters}
									onChange={applySorting}
								/>
							</div>
						</div>
					</div>
					<Button
						type="text"
						icon={<CloseOutlined />}
						onClick={() => setShowScheduleWOs((prev) => !prev)}
					/>
				</div>
				<Divider style={{ margin: '16px 0 0 0' }} />
			</>
		),
		[scopedTechnicianEmail, scopedTechnicianLabel]
	);

	useMountEffect(() => {
		setScrollToTime(moment().subtract(4, 'hour').toDate());
	});

	const lastSyncedTechEmailRef = useRef<string | undefined>();

	useEffect(() => {
		if (!showScheduleWOs) {
			return;
		}

		if (!syncScheduleTechnicianFilter) {
			return;
		}

		const nextEmail = scopedTechnicianEmail || undefined;

		if (lastSyncedTechEmailRef.current === nextEmail) {
			return;
		}

		lastSyncedTechEmailRef.current = nextEmail;

		syncScheduleTechnicianFilter({
			fieldTechnicianVisibilityEmail: nextEmail,
		});
	}, [showScheduleWOs, scopedTechnicianEmail, syncScheduleTechnicianFilter]);

	// Memoize CustomWorkOrderRowDisplayProps to prevent unnecessary re-renders
	const customWorkOrderRowDisplayProps = useMemo(
		() => ({
			onRefreshTable: (scheduledTime) => {
				if (scheduledTime) {
					const scheduledMoment = moment(scheduledTime);
					if (scheduledMoment.isValid()) {
						const scheduledDate = scheduledMoment.toDate();
						setScrollToTime(scheduledDate);
						if (calendarView === Views.DAY) {
							setCalendarDate(scheduledDate);
							updateDateFiltersForView(calendarView, scheduledDate);
						} else {
							fetchData(location, calendarDate, calendarView);
						}
					}
				} else {
					// If no scheduled time, just refresh the data
					fetchData(location, calendarDate, calendarView);
				}
			},
			leadTechnicianEmail: scopedTechnicianEmail,
			serviceScheduledAt: calendarView === Views.DAY ? moment() : null,
		}),
		[
			calendarView,
			calendarDate,
			updateDateFiltersForView,
			fetchData,
			location,
			scopedTechnicianEmail,
		]
	);

	// Memoize renderEmptyState callback
	const renderEmptyState = useCallback(() => <EmptyState headline="No open work orders" />, []);

	const scheduleWorkOrdersPreAppliedFilters = useMemo(() => {
		const baseFilters = {
			unscheduledOrPastSchedule: true,
			statuses: isInternalTeam
				? 'Unassigned,AssignedToInternalTech,TechCancelled,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason'
				: 'PendingConfirmationByServiceProvider,TechCancelled,PendingConfirmationByServiceProvider,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason',
		};
		if (scopedTechnicianEmail) {
			return {
				...baseFilters,
				fieldTechnicianVisibilityEmail: scopedTechnicianEmail,
			};
		}
		return baseFilters;
	}, [scopedTechnicianEmail, isInternalTeam]);

	return (
		<Content className="supplierWorkOrdersIndexPage relative" style={{ padding: '0 0.5em' }}>
			{showScheduleWOs ? null : (
				<div
					className=" absolute left-[-7px]  top-1/2 z-50 mx-0 flex -translate-y-1/2 transform cursor-pointer flex-row items-center justify-center gap-1  bg-white px-1  py-3 font-medium tracking-wide text-supplier"
					style={{
						writingMode: 'sideways-lr',
						textOrientation: 'mixed',
						border: '1px solid var(--Grey-5, #D9D9D9)',
						position: 'absolute',
						transform: 'translateY(-50%)',
						borderRadius: '0 10px 10px 0px',
					}}
					onClick={() => setShowScheduleWOs(!showScheduleWOs)}
				>
					<span>Schedule Work Orders</span>
					<CaretDownFilled style={{ transform: 'rotate(270deg)' }} />
				</div>
			)}
			<Row key={2} style={{ margin: '1 -8px' }} gutter={[12, 12]}>
				<Col span={24}>
					<SubnavBar
						left={
							<div className="mt-2 flex flex-row flex-wrap items-center gap-3">
								<Filters
									filterConfig={FILTER_CONFIG}
									currentUser={currentUser}
									applyFilters={updateFilters}
									filters={nullSafeGetOrElse(`filters`, workOrders, {})}
									clearFilters={handleClearAndUpdateFilters}
									targetCollectionName={WORK_ORDERS_CALENDAR_TARGET_COLLECTION}
									userType={ROLE_TYPES.SUPPLIER}
									preAppliedFilters={calendarPreAppliedFilters}
									sorterItems={[]}
								/>

								<AssignedFilters
									items={assignedFilterItems}
									currentUser={currentUser}
									userType={ROLE_TYPES.SUPPLIER}
									value={assignedFilterValue}
									onChange={handleAssignedFilterChange}
									selector={ASSIGNED_FILTERS(currentUser).selector}
								/>
								<SubcontractedFilters
									items={SUBCONTRACTED_FILTERS(currentUser).items}
									currentUser={currentUser}
									userType={ROLE_TYPES.SUPPLIER}
									value={nullSafeGetOrElse(`filters`, workOrders, {})}
									onChange={updateFilters}
									selector={SUBCONTRACTED_FILTERS(currentUser).selector}
								/>
							</div>
						}
						right={null}
					/>
				</Col>
			</Row>
			<SelectedFilters
				updateFilters={updateFilters}
				filterValues={nullSafeGetOrElse(`filters`, workOrders, {})}
				filterConfig={FILTER_CONFIG}
				containerClassName="mt-3"
			/>
			{/* The fetch is bounded to the visible day/week and capped at CALENDAR_PAGE_SIZE, so say so
			    rather than quietly dropping the overflow. Only the day/week switch and the filter drawer
			    refetch — the Techs control just picks which already-loaded columns to show, and this page
			    drops the technician filter altogether (see FILTER_CONFIG) — so those are the only
			    remedies worth naming. */}
			{nullSafeGetOrElse('total', pagination, 0) >
			nullSafeGetOrElse('pageSize', pagination, CALENDAR_PAGE_SIZE) ? (
				<Alert
					className="mt-3"
					type="warning"
					showIcon
					message={`Showing the first ${nullSafeGetOrElse(
						'pageSize',
						pagination,
						CALENDAR_PAGE_SIZE
					)} of ${pagination.total} work orders. ${
						isWeekView ? 'Switch to Day view or narrow' : 'Narrow'
					} the filters to see the rest.`}
				/>
			) : null}
			<Row key={3} style={{ margin: '12px 0px' }} gutter={16} align="stretch" className="relative">
				{showScheduleWOs ? (
					<Col span={8} className="animate-slideInFromLeft">
						<Card
							style={{
								minHeight: 560,
								maxHeight: '100vh',
								padding: 0,
								height: '100%',
								display: 'flex',
								flexDirection: 'column',
							}}
							bodyStyle={{
								padding: 0,
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								overflow: 'scroll',
							}}
						>
							<WorkOrderTable
								ignoreRefreshCounts={true}
								handleQueryParams={false}
								preAppliedFilters={scheduleWorkOrdersPreAppliedFilters}
								CustomHeader={customHeader}
								CustomWorkOrderRowDisplay={ServiceCalendarWorkOrderRow}
								CustomWorkOrderRowDisplayProps={customWorkOrderRowDisplayProps}
								renderEmptyState={renderEmptyState}
								targetCollectionName={WORK_ORDERS_SCHEDULE_TARGET_COLLECTION}
							/>
						</Card>
					</Col>
				) : null}

				<Col span={showScheduleWOs ? 16 : 24} className="!p-0">
					<Card
						style={{
							minHeight: 560,
							maxHeight: '100vh',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							position: 'relative',
							marginLeft: 0,
						}}
						bodyStyle={{
							padding: 0,
							flex: 1,
							display: 'flex',
							flexDirection: 'column',
							overflow: 'hidden',
							position: 'relative',
						}}
					>
						{fetching && (
							<div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-80">
								<Spin size="large" />
							</div>
						)}
						<CustomCalendarToolbar
							date={calendarDate}
							view={calendarView}
							views={CALENDAR_TOOLBAR_VIEWS}
							onNavigate={handleToolbarNavigate}
							onView={handleCalendarViewChange}
							leftExtra={
								<TechnicianFilterPopover
									technicians={technicians}
									technicianCount={technicianCount}
									selectedEmails={resolvedTechnicianEmails}
									usingDefaultSelection={technicianSelection === null}
									onChange={handleTechnicianSelectionChange}
									fetching={loadingAllTechnicians}
									loading={loadingAllTechnicians}
								/>
							}
							compact={showScheduleWOs}
						/>
						<TechnicianNavContext.Provider value={technicianNavValue}>
							{!isWeekView && !loadingAllTechnicians && orderedTechnicians.length === 0 ? (
								<EmptyState
									height={320}
									headline={
										currentUserHasNoTechnicianRecord
											? 'Nothing assigned to you'
											: 'No technician columns'
									}
									body={
										<div className="max-w-[488px] text-center">
											{currentUserHasNoTechnicianRecord
												? 'You do not have any work orders assigned to you. Choose All to see the team.'
												: 'Open Techs to pick who appears on the calendar.'}
										</div>
									}
								/>
							) : (
								<EventCalendar
									toolbar={false}
									events={visibleEvents}
									date={calendarDate}
									view={calendarView}
									defaultView={Views.DAY}
									scrollToTime={scrollToTime}
									onNavigate={handleCalendarNavigate}
									onView={handleCalendarViewChange}
									views={{ week: true, day: true }}
									components={CALENDAR_COMPONENTS}
									resources={calendarView === Views.DAY ? technicianResources : undefined}
									scrollApiRef={calendarScrollApiRef}
									onResourceScrollIndexChange={setVisibleTechnicianOffset}
									resourceIdAccessor="email"
									resourceTitleAccessor={renderTechnicianColumnHeader}
									resourceAccessor="technicianEmails"
									dayLayoutAlgorithm={stackingLayout}
									resizable={false}
									onEventDrop={handleEventDrop}
									draggableAccessor={draggableAccessor}
									resourceColumnCount={calendarView === Views.DAY ? resourceColumnCount : undefined}
									step={15}
									timeslots={4}
								/>
							)}
						</TechnicianNavContext.Provider>
					</Card>
				</Col>
			</Row>
			{rescheduleModalVisible && selectedWorkOrder && (
				<ScheduleServiceCallModalForm
					wrappedComponentRef={(ref) => {
						rescheduleFormRef.current = ref;
					}}
					formData={{
						...nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {}),
						workOrder: selectedWorkOrder,
						leadTechnicianEmail:
							dropTechnicianEmail ||
							nullSafeGet('lastServiceCall.leadTechnicianEmail', selectedWorkOrder),
						serviceScheduledAt: newScheduledTime
							? moment(newScheduledTime)
							: nullSafeGet(
									'serviceScheduledAt',
									nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
							  )
							? moment(
									nullSafeGet(
										'serviceScheduledAt',
										nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
									)
							  )
							: undefined,
					}}
					isReschedule={true}
					visible={rescheduleModalVisible}
					onCancel={handleRescheduleCancel}
					onSubmit={handleRescheduleSubmit}
					initialTimeZone={myTimeZone}
				/>
			)}
			{scheduleModalVisible && selectedWorkOrder && (
				<ScheduleServiceCallModalForm
					wrappedComponentRef={(ref) => {
						scheduleFormRef.current = ref;
					}}
					formData={{
						workOrder: selectedWorkOrder,
						workOrderId: selectedWorkOrder.id,
						leadTechnicianEmail: dropTechnicianEmail || undefined,
						supplierFacilityId: nullSafeGetOrElse('supplierFacilityId', selectedWorkOrder, null),
						serviceScheduledAt: newScheduledTime ? moment(newScheduledTime) : undefined,
					}}
					visible={scheduleModalVisible}
					onCancel={handleScheduleCancel}
					onSubmit={handleScheduleSubmit}
					initialTimeZone={myTimeZone}
				/>
			)}
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	location: ownProps.location,
	workOrders: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION] || {},
	data: selectCalendarWorkOrders(state),
	fetching: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION]
		? state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION].fetching
		: false,
	locations: state.locations,
	workOrderPriorities: state.work_order_priorities,
	fieldTechs: state.field_techs,
	technicians: selectCalendarTechnicians(state),
	technicianCount: nullSafeGetOrElse(
		`${SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION}.count`,
		state.field_techs,
		0
	),
	assetTypes: state.asset_types,
	assets: state.assets,
	contractorPrivateNetworks: state.contractor_private_networks,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	regions: state.regions,
	areas: state.areas,
	resolutionTypes: state.resolution_types,
	supplierFacilities: state.supplier_facilities,
	planned_maintenance_schedules: state.planned_maintenance_schedules,
	contractorClients: state.contractor_clients,
	contractorLocations: state.contractor_locations,
	users: state.all_contacts,
	brands: state.brands,
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch, ownProps) => {
	const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
	const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

	return {
		fetchData: (location, date, view) => {
			// Use provided date/view, or fall back to current day/DAY view
			const selectedDate = date || new Date();
			const selectedView = view || Views.DAY;
			const { startDate, endDate } = calculateDateRangeForView(selectedView, selectedDate);

			return dispatch(
				fetchWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					location,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					{
						[startDateFieldName]: startDate,
						[endDateFieldName]: endDate,
						[getWorkOrderArchivalKey(ownProps.currentUser)]: false,
						fieldTechnicianEmail: undefined,
					},
					{ current: 1, pageSize: CALENDAR_PAGE_SIZE },
					ownProps.initialSorting,
					ownProps.initialFilters,
					false
				)
			);
		},
		updateFilters: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					filters,
					false // ignoreRefreshCounts
				)
			),
		clearFilters: (preserveFilters) =>
			dispatch(
				clearFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					preserveFilters,
					false // ignoreRefreshCounts
				)
			),
		fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
			dispatch(
				workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
			),
		fetchWorkOrderPriorities: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				workOrderPrioritiesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchAssetTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				assetTypesRestCrudThunksForSupplier.readLite(
					{ ...params, no_pagination: true },
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleAssetTypes: (ids, targetCollectionName) =>
			dispatch(assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
			dispatch(resolutionTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchResolutionTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				resolutionTypesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchProblemTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				problemTypesHeirarchicalForSupplier(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchSupplierFacilitiesInPrivateNetwork: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fetchSupplierFacilitiesInPrivateNetworkForSupplier(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchPMSchedule: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				plannedMaintenanceSchedulesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultiplePMSchedule: (ids, targetCollectionName) =>
			dispatch(
				plannedMaintenanceSchedulesRestCrudThunksForSupplier.readMultiple(
					ids,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION
				)
			),
		fetchAllFieldTechs: () =>
			dispatch(
				fetchAllFieldTechs(ROLE_TYPES.SUPPLIER)(SERVICE_CALENDAR_TECHNICIANS_TARGET_COLLECTION)
			),
		fetchMultipleFieldTechs: (ids, targetCollectionName) =>
			dispatch(fieldTechsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchFieldTechs: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fieldTechsRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchSpendCategories: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				spendCategoriesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleSpendCategories: (ids, targetCollectionName) =>
			dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchAssets: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				assetsRestReadThunk(
					ROLE_TYPES.SUPPLIER,
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleAssets: (ids, targetCollectionName) =>
			dispatch(assetsRestReadThunk(ROLE_TYPES.SUPPLIER, { ids }, targetCollectionName)),
		fetchContractors: (params, targetCollectionName) =>
			dispatch(
				ContractorPrivateNetworksRestCrudThunksForSupplier.read(params, targetCollectionName)
			),
		fetchAreasDistinct: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fetchDistinctAreasHeirarchy(ownProps.userType)(
					{ ...params, no_pagination: true },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),

		fetchContractorClients: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contractorClientsRestCrudThunksForSupplier.read(
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleContractorClients: (ids, targetCollectionName) =>
			dispatch(contractorClientsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchContractorLocations: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contractorLocationsRestCrudThunksForSupplier.read(
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleContractorLocations: (ids, targetCollectionName) =>
			dispatch(
				contractorLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
			),
		fetchUsers: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleUsers: (emails, targetCollectionName) =>
			dispatch(
				contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
					{ emails },
					targetCollectionName
				)
			),
		fetchBrands: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				brandsRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleBrands: (ids, targetCollectionName) =>
			dispatch(brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		rescheduleServiceCall: (serviceCall) => dispatch(rescheduleServiceCallForSupplier(serviceCall)),
		scheduleServiceCall: (serviceCall) => dispatch(scheduleServiceCallForSupplier(serviceCall)),
		getFullWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
		syncScheduleTechnicianFilter: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					false, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_SCHEDULE_TARGET_COLLECTION,
					filters,
					true // ignoreRefreshCounts for schedule table
				)
			),
	};
};

export default withRouter(
	withUserType(
		withCurrentUser(
			connect(mapStateToProps, mapDispatchToProps)(SupplierServiceCallCalendarPageV2 as any)
		)
	)
);
